import { Box, Typography } from "@mui/material";

const style = () => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  };
};

const SummaryValue = ({ label, value }) => {
  return (
    <Box className="summary-value" sx={() => style()} my={0.5}>
      <Typography variant="subtitle1">{label}</Typography>
      <Typography variant="subtitle1" fontWeight={500} color="#231F20">
        {value}
      </Typography>
    </Box>
  );
};

export default SummaryValue;
